import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Styles
import styles from './index.module.sass';

// Images
import TRIANGLE from '../../images/menu/triangle-greyblue.png';

//Objects
import accountObject from '../Queries/myAccountObject';

// Queries
import closeSession from '../Queries/closeSession';

export default function MyAccount({ history, getCookie }) {
  const { location = {} } = history;
  const { hash = '' } = location;
  const [itemSelected, setItemSelected] = useState(false);
  const { url = '', children = [] } = accountObject || {};

  const { t } = useTranslation('menuheader');

  let itemTimeout;

  const cont = process.env.REACT_APP_COUNTRY;

  return (
    <div
      className={styles.departamentContainer}
      onMouseEnter={() => {
        clearTimeout(itemTimeout);
        setItemSelected(true);
      }}
      onMouseLeave={() => {
        itemTimeout = setTimeout(function () {
          setItemSelected(false);
        }, 200);
      }}
      onClick={() => {
        if (itemSelected) setItemSelected(false);
        else setItemSelected(true);
      }}
      style={{
        order: accountObject.index,
      }}>
      <div className={styles.userIcon}>
        <i className={`material-icons-outlined ${styles.myAccountIcon}`}>person</i>
        <div className={styles.myaccount}>{t('myaccount')}</div>
        <div className={`${styles.families} ${styles[itemSelected && children.length > 0]}`}>
          <img src={TRIANGLE} alt='' className={styles.triangle} />
          <div className={styles.kitData}>
            <div className={styles.avatar}>
              <i className={`material-icons-outlined ${styles.avaterIcon}`}>person</i>
            </div>
            <div>
              <div>{getCookie('kitName')}</div>
              <div>{getCookie('usuario')}</div>
            </div>
          </div>
          {children.map((subval, subkey) => {
            const external = (
              <a
                className={styles.familyTitle}
                key={subkey}
                href={`${subval.url}`}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                  setItemSelected(false);
                }}>
                <span className={`material-icons-outlined ${styles.familyIcon}`}>
                  {subval?.icon || 'arrow_right_alt'}
                </span>
                <div>{t(subval.id)}</div>
              </a>
            );

            const normal = (
              <Link
                className={styles.familyTitle}
                key={subkey}
                to={`${url}${subval.url}${hash}`}
                onClick={() => {
                  setItemSelected(false);
                }}>
                <span className={`material-icons-outlined ${styles.familyIcon}`}>
                  {subval?.icon || 'arrow_right_alt'}
                </span>
                <div>{t(subval.id)}</div>
              </Link>
            );
            if (subval.external) {
              if (subval.country && subval.country === cont) return external;
              else if (subval.country && subval.country !== cont) return null;
              else return external;
            } else {
              if (subval.country && subval.country === cont) return normal;
              else if (subval.country && subval.country !== cont) return null;
              else return normal;
            }
          })}
          <div
            className={styles.familyTitle}
            onClick={() => {
              setItemSelected(false);
              closeSession({ history });
            }}>
            <span className={`material-icons-outlined ${styles.familyIcon}`}>logout</span>
            <div>{t('logout')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
